import { useEffect, useRef } from 'react';
import { getAblyClient } from '../lib/ably';

export function useAblyComments(
  artifactId: string | undefined,
  onCommentEvent: () => void,
) {
  const channelRef = useRef<any>(null);

  useEffect(() => {
    if (!artifactId) return;

    let mounted = true;

    async function subscribe() {
      const client = await getAblyClient();
      if (!client || !mounted) return;

      const channel = client.channels.get(`artifact:${artifactId}`);
      channelRef.current = channel;

      channel.subscribe((message) => {
        // Any comment event triggers a refresh
        if (message.name?.startsWith('comment.') || message.name?.startsWith('reaction.')) {
          onCommentEvent();
        }
      });
    }

    subscribe();

    return () => {
      mounted = false;
      if (channelRef.current) {
        channelRef.current.unsubscribe();
        channelRef.current = null;
      }
    };
  }, [artifactId, onCommentEvent]);
}
